// extracted by mini-css-extract-plugin
export default {"btnWrapper":"styles_btnWrapper__ze6yb","submitBtn":"styles_submitBtn__wmMwW","iconWrapper":"styles_iconWrapper__82JNG"};